<template>
    <div class="section mt-1">
        <div class="goals">
            <div class="meeting-grid">
                <div class="meeting-card">
                    <div class="meeting-link">
                        <div class="in">
                            <div>
                                <h3 class="meeting-title">{{ responseData.meeting.meeting_name_mal && responseData.meeting.meeting_name_mal !== 'N' ? responseData.meeting.meeting_name_mal : responseData.meeting.meeting_name }}</h3>
                                <p class="meeting-comment"><span v-if="responseData.meeting.meeting_period">{{ $t('meeting_period') }}: {{
                                    responseData.meeting.meeting_period
                                }}</span></p>
                            </div>
                            <span class="status-badge price mal-text">
                                <ion-icon name="checkmark-circle-outline" class="price-icon" :title="$t('conducted')"></ion-icon>
                            </span>
                        </div>
                        <hr>
                        <div class="meeting-details-compact">
                            <div class="meeting-info-compact">
                                <span class="info-item">
                                    <ion-icon name="calendar-outline"></ion-icon>
                                    {{ responseData.meeting.meeting_display_date ? responseData.meeting.meeting_display_date : '--/--/----' }}
                                </span>
                                <span class="info-separator">/</span>
                                <span class="info-item">
                                    <ion-icon name="time-outline"></ion-icon>
                                    {{ responseData.meeting.meeting_time ? responseData.meeting.meeting_time : '--:--' }}
                                </span>
                                <span class="info-separator">/</span>
                                <span class="info-item">
                                    <ion-icon name="people-outline"></ion-icon>
                                    {{ participantsWithAttendance || '---' }}
                                </span>
                            </div>
                            <div class="meeting-location-compact">
                                <ion-icon name="location-outline"></ion-icon>
                                <span>{{ responseData.meeting.meeting_location ? responseData.meeting.meeting_location : '---' }}</span>
                            </div>
                        </div>
                        <hr>
                        <!-- <div class="status-footer">
                            <span class="status-box">
                                <span class="status-text">Status:{{}}</span>
                            </span>
                        </div> -->
                     <!-- <div class="progress">
                        <div class="progress-bar" role="progressbar" style="width: 85%;" aria-valuenow="85"
                            aria-valuemin="0" aria-valuemax="100">85%</div>
                    </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ul class="listview image-listview text inset mt-1" v-if="responseData.permissions.self_coming_view">
        <li>
            <div class="item">
                <div class="in">
                    <div class="mal-text">
                        {{ $t('i_will_attend') }}
                    </div>
                    <div class="form-check form-switch  ms-2" v-if="responseData.permissions.self_coming_create">
                        <input class="form-check-input" type="checkbox" id="selfAttendance" v-model="self_coming_btn"
                            @change="selfComing" :disabled="responseData.participant_details.coming == 'P'">
                        <label class="form-check-label" for="selfAttendance">
                        </label>
                    </div>
                </div>
            </div>
        </li>
    </ul>
    <ul class="listview image-listview text inset mt-1" v-if="responseData.permissions.self_attendance_view">
        <li>
            <div class="item">
                <div class="in">
                    <div>
                        {{ $t('my_attendance') }}
                        <!-- <div class="text-muted">
                            Send notification when new payment received
                        </div> -->
                    </div>
                    <div class="form-check form-switch  ms-2" v-if="responseData.permissions.self_attendance_create">
                        <input class="form-check-input" type="checkbox" id="selfAttendance" v-model="self_attendance_btn"
                            @change="selfAttendance" :disabled="responseData.participant_details.attendance == 'P'">
                        <label class="form-check-label" for="selfAttendance">
                        </label>
                    </div>
                </div>
            </div>
        </li>
        <li v-if="responseData.participant_details.attendance == 'P'">
            <a href="javascript:void(0)" class="item">
                <div class="in text-center">
                    <!-- <div>ID#</div> -->
                    <h3 class="text-primary">{{ $t('participant_id') }}:</h3>
                    <h2 class="text-danger mr-2">{{ responseData.participant_details.id }}</h2>

                </div>
            </a>
        </li>
    </ul>
    <ul class="listview image-listview text inset mt-1"
        v-if="responseData.meeting && responseData.meeting.meeting_link">
        <li>
            <div class="item">
                <div class="in">
                    <div class="text-dark">
                        {{ $t('meeting_link') }} :
                        <a class="text-primary" :href="responseData.meeting.meeting_link" target="_blank">{{responseData.meeting.meeting_link}}</a>
                    </div>
                </div>
            </div>
        </li>
    </ul>
    <div class="section mt-1">
        <ul class="nav nav-tabs lined" role="tablist">
            <li class="nav-item" v-if="responseData.permissions.view_details">
                <a class="nav-link active" data-bs-toggle="tab" href="javascript:void(0)" role="tab"
                    @click="goToTab('tabD')">
                    {{ responseData.heading.details }}
                </a>
            </li>
            <li class="nav-item" v-if="responseData.permissions.view_participants">
                <a class="nav-link" data-bs-toggle="tab" href="javascript:void(0)" role="tab" @click="goToTab('tabP')">
                    {{ responseData.heading.participants }}
                </a>
            </li>
            <li class="nav-item" v-if="responseData.permissions.view_agenda">
                <a class="nav-link" data-bs-toggle="tab" href="javascript:void(0)" role="tab" @click="goToTab('tabA')">
                    {{ responseData.heading.agenda }}
                </a>
            </li>
            <li class="nav-item" v-if="responseData.permissions.view_minutes">
                <a class="nav-link" data-bs-toggle="tab" href="javascript:void(0)" role="tab" @click="goToTab('tabM')">
                    {{ responseData.heading.minutes }}
                </a>
            </li>
            <li class="nav-item" v-if="responseData.permissions.view_history">
                <a class="nav-link" data-bs-toggle="tab" href="javascript:void(0)" role="tab" @click="goToTab('tabH')">
                    {{ responseData.heading.history }}
                </a>
            </li>
        </ul>
    </div>
    <div class="section text-center mt-1" v-if="loading">
        <div class="spinner-border text-primary" role="status"></div>
    </div>
    <div class="section pt-2"
        v-if="(responseData.permissions.attendance_report || responseData.permissions.attendance_qr_code) && tabP && !loading">
        <div class="wallet-card mt-1">
            <div class="wallet-footer wallet-footer-user row">
                <div class="item col-4" v-if="responseData.permissions.attendance_report">
                    <router-link :to="'/meeting/' + this.$route.params.id + '/attendance-report'">
                        <a href="javascript:void(0)">
                            <div class="icon-wrapper bg-success">
                                <ion-icon name="checkmark-done-outline"></ion-icon>
                                <strong class="menu-title">{{ $t('report') }}</strong>
                            </div>
                        </a>
                    </router-link>
                </div>
                <div class="item col-4" v-if="responseData.permissions.attendance_qr_code">
                    <router-link :to="'/meeting/' + this.$route.params.id + '/qr-code-generator'">
                        <a href="javascript:void(0)">
                            <div class="icon-wrapper bg-primary">
                                <ion-icon name="qr-code-outline"></ion-icon>
                                <strong class="menu-title">{{ $t('qr_code') }}</strong>
                            </div>
                        </a>
                    </router-link>
                </div>
                <div class="item col-4" v-if="responseData.permissions.attendance_qr_code">
                    <router-link :to="'/meeting/' + this.$route.params.id + '/qr-code-scanner'">
                        <a href="javascript:void(0)">
                            <div class="icon-wrapper bg-danger">
                                <ion-icon name="scan-outline"></ion-icon>
                                <strong class="menu-title">{{ $t('scanner') }}</strong>
                            </div>
                        </a>
                    </router-link>
                </div>

            </div>
        </div>
    </div>
    <div id="search" v-if="tabP">
        <form class="search-form">
            <div class="form-group searchbox">
                <input type="text" class="form-control" placeholder="ഇവിടെ സെർച്ച് ചെയ്യുക..." v-model="search_qty"
                    @input="getMeetings(1, 'Details')">
                <i class="input-icon">
                    <ion-icon name="search-outline"></ion-icon>
                </i>
            </div>
        </form>
    </div>
    <div id="search" v-if="tabP">
        <form class="search-form">
            <div class="form-group searchbox mal-text">
                <select as="select" class="form-control custom-select" v-model="filter_attendance"
                    id="select4" @input="getMeetings(1, 'Details',$event.target.value)">
                    <option value="All">{{ $t('all') }}</option>
                    <option value="P">{{ $t('present') }}</option>
                    <option value="A">{{ $t('absent') }}</option>
                    <option value="L">{{ $t('leave') }}</option>
                </select>
                <i class="input-icon">
                    <ion-icon name="filter-outline"></ion-icon>
                </i>
            </div>
        </form>
    </div>
    <!-- Filter Section with Accordion (same design as QVPList.vue) -->
    <div class="section inset mt-1 mb-1" v-if="tabP && !loading && (isStateAdmin || isDistrictAdmin)">
        <div class="accordion" id="accordionMeetingFilter">
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#meetingFilterAccordion" aria-expanded="false">
                        <ion-icon name="filter-outline" role="img" class="md hydrated"
                            aria-label="filter outline"></ion-icon>
                        Filter
                    </button>
                </h2>
                <div id="meetingFilterAccordion" class="accordion-collapse collapse" :class="hasActiveParticipantFilters ? 'show' : ''"
                    data-bs-parent="#accordionMeetingFilter">
                    <div class="accordion-body">
                        <div id="meetingFilterContent" style="padding: 0px !important;">
                            <!-- District Filter (State Admin only) -->
                            <div v-if="isStateAdmin" class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="meeting_filter_district">District</label>
                                    <select class="form-control custom-select" v-model="filter_district_id"
                                        name="meeting_filter_district" id="meeting_filter_district" @change="onFilterDistrictChange">
                                        <option value="">---All---</option>
                                        <option v-for="d in district_list" :key="d.id" :value="String(d.id)">{{ d.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <!-- Zone Filter -->
                            <div class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="meeting_filter_zone">Zone</label>
                                    <select class="form-control custom-select" v-model="filter_zone_id"
                                        name="meeting_filter_zone" id="meeting_filter_zone" @change="onFilterZoneChange">
                                        <option value="">---All---</option>
                                        <option v-for="z in zone_list" :key="z.id" :value="String(z.id)">{{ z.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <!-- Unit Filter -->
                            <div class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="meeting_filter_unit">Unit</label>
                                    <select class="form-control custom-select" v-model="filter_unit_id"
                                        name="meeting_filter_unit" id="meeting_filter_unit" @change="onFilterUnitChange">
                                        <option value="">---All---</option>
                                        <option v-for="u in unit_list" :key="u.id" :value="String(u.id)">{{ u.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ul class="listview image-listview inset text mt-1" v-if="tabP && !loading">
        <li>
            <a href="javascript:void(0)" class="item">
                <span class="sl-no"></span>
                <div class="in">
                    <div class="min-width-50">
                        <header></header>
                        <b>{{ responseData.heading.participants }}</b>
                        <footer> </footer>
                    </div>
                    <div class="card-button" v-if="responseData.permissions.update_participants">
                        <button type="button" class="btn btn-icon btn-primary me-1" @click="showAddParticipantModal">
                            <ion-icon name="add-outline" class="md hydrated"></ion-icon>
                        </button>
                    </div>
                </div>
            </a>
        </li>
        <li v-if="responseData.permissions.update_participants && hasUnmarkedParticipants && isMeetingToday" class="mark-attendance-section">
            <div class="item d-flex align-items-center justify-content-between flex-wrap gap-2">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="selectAllMeetingAttendance"
                        :checked="allPageParticipantsPresent"
                        :disabled="bulkMarkingAttendance"
                        @change="onSelectAllAttendanceChange">
                    <label class="form-check-label" for="selectAllMeetingAttendance">Select all</label>
                </div>
                <small class="text-muted" v-if="bulkMarkingAttendance">Saving...</small>
            </div>
        </li>
        <li v-for="(member_list, index) in responseData.participants.data" v-bind:key="member_list.id"
            :set="background = (member_list.attendance) == 'P' ? 'rgb(209 232 210)' : (member_list.attendance) == 'A' || member_list.attendance == 'L' ? 'rgb(242 187 202)' : (member_list.attendance) == 'N' ? '#ffffff' : '#ffffff'"
            :style="{ 'background-color': background }">
            <a href="javascript:void(0)" class="item" v-if="member_list.member">
                <div class="meeting-attendance-check-wrap" v-if="responseData.permissions.update_participants && isMeetingToday" @click.stop>
                    <input type="checkbox" class="form-check-input meeting-attendance-check"
                        :checked="member_list.attendance == 'P'"
                        :disabled="markingAttendanceIds.includes(member_list.id)"
                        @change="onAttendanceCheckboxChange(member_list, $event)"
                        :id="'meeting_attendance_' + member_list.id">
                </div>
                <span class="sl-no">{{ responseData.participants.from + index }}.</span>
                <div class="avatar-section">
                    <a href="#">
                        <img v-if="member_list.member.avatar != 'member.jpg' && member_list.member.avatar != null"
                            :src="'https://guide.msoftit.com/' + member_list.member.avatar" alt="avatar" class="image">
                        <img v-if="!member_list.member.avatar || member_list.member.avatar == 'member.jpg'"
                            :src="'assets/img/sample/avatar/avatar1.png'" alt="avatar" class="image">
                    </a>
                </div>
                <div class="in">
                    <div class="min-width-50">
                        <header>{{member_list.designation}}</header>
                        <span v-if="member_list.coming_status == 'P'" class="participant-coming-badge">പങ്കെടുക്കും</span>
                        <b> {{ member_list.member.name }} </b>
                        <footer>{{ member_list.member.country_code }} {{ member_list.member.mobile }}
                            <br v-if="member_list.attendance == 'P'">
                            <span v-if="member_list.attendance == 'P'" class="text-danger">{{ $t('participant_id') }}: {{ member_list.id }}</span>
                        </footer>
                    </div>
                    <div class="card-button dropdown">
                        <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                            :data-bs-target="'#actionSheetInset' + member_list.member.id" @click="showActionModel">
                            <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                        </button>
                    </div>

                    <!-- Default Action Sheet Inset -->
                    <div class="modal fade action-sheet" :id="'actionSheetInset' + member_list.member.id" tabindex="-1"
                        role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">{{ $t('action') }}</h5>
                                </div>
                                <div class="modal-body">
                                    <ul class="action-button-list">
                                        <li>
                                            <a :href="'tel:' + member_list.member.mobile" class="btn btn-list">
                                                <span>
                                                    <ion-icon name="call-outline"></ion-icon> {{ $t('call') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="member_list.member.whatsapp">
                                            <a :href="'https://wa.me/' + member_list.member.whatsapp_country_code + member_list.member.whatsapp + '?text='"
                                                class="btn btn-list">
                                                <span>
                                                    <ion-icon name="logo-whatsapp"></ion-icon> {{ $t('whatsapp') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="responseData.permissions.update_participants && isMeetingToday">
                                            <a href="javascript:void(0)" @click="attendanceOpen(member_list)"
                                                class="btn btn-list" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="checkmark-done-outline"></ion-icon>{{ $t('attendance') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li class="action-divider"></li>
                                        <li>
                                            <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="close-outline"></ion-icon> {{ $t('cancel') }}
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- * Default Action Sheet Inset -->
                </div>
            </a>
        </li>
    </ul>
    <div class="section mt-2" v-if="tabP && !loading">
        <vue-awesome-paginate v-if="responseData.participants.total > 0" :total-items="responseData.participants.total"
            :items-per-page="responseData.participants.per_page" :max-pages-shown="3"
            v-model="responseData.participants.current_page" :on-click="getMeetings" :show-ending-buttons="true"
            :show-breakpoint-buttons="false" />
    </div>
    <div class="section mt-1" v-if="!loading && tabD">
        <div class="card mb-2" v-if="responseData.permissions.view_my_duties">
            <div class="card-header text-primary">{{ $t('my_duties') }}</div>
            <div class="card-body">
                <p class="card-text text-dark">
                <ol>
                    <li v-for="duty in responseData.my_duties" v-bind:key="duty.id">{{ duty.agenda }}</li>
                </ol>
                </p>
            </div>
        </div>
        <Form @submit="meetingDetailSave" v-if="responseData.permissions.view_details_form">
            <div class="card">
                <div class="card-body">
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label" for="pin">{{ $t('date') }}</label>
                            <!-- Wisdom Day: restrict to August 23 & 24 of the meeting year -->
                            <Field v-if="responseData.meeting.meeting_sublevel == 7"
                                as="select" class="form-control custom-select" name="meeting_date" v-model="meeting_date"
                                :disabled="!responseData.permissions.update_details || !responseData.permissions.update_date">
                                <option value="">Select Date</option>
                                <option :value="wisdomDayDate(23)">{{ wisdomDayDate(23) }} (August 23)</option>
                                <option :value="wisdomDayDate(24)">{{ wisdomDayDate(24) }} (August 24)</option>
                            </Field>
                            <Field v-else type="date" class="form-control" name="meeting_date" v-model="meeting_date"
                                :disabled="!responseData.permissions.update_details || !responseData.permissions.update_date" />
                            <i class="clear-input">
                                <ion-icon name="close-circle"></ion-icon>
                            </i>
                        </div>
                        <ErrorMessage name="meeting_date" class="error-feedback" />
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label" for="pin">{{ $t('time') }}</label>
                            <Field type="time" class="form-control" name="meeting_time" v-model="meeting_time"
                                :disabled="!responseData.permissions.update_details || !responseData.permissions.update_time" />
                            <i class="clear-input">
                                <ion-icon name="close-circle"></ion-icon>
                            </i>
                        </div>
                        <ErrorMessage name="meeting_time" class="error-feedback" />
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label" for="code">{{ $t('meeting_mode') }}</label>
                            <Field as="select" class="form-control custom-select" id="meeting_mode" name="meeting_mode"
                                v-model="meeting_mode"
                                :disabled="!responseData.permissions.update_details || !responseData.permissions.update_mode">
                                <option value="" :disabled="true" selected>{{ $t('select_meeting_mode') }}</option>
                                <option value="Physical">{{ $t('physical') }}</option>
                                <option value="Online">{{ $t('online') }}</option>
                            </Field>
                        </div>
                        <ErrorMessage name="meeting_mode" class="error-feedback" />
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label" for="pin">{{ $t('location') }}</label>
                            <Field type="text" class="form-control" name="meeting_location" placeholder="Meeting Location"
                                v-model="meeting_location"
                                :disabled="!responseData.permissions.update_details || !responseData.permissions.update_location" />
                            <i class="clear-input">
                                <ion-icon name="close-circle"></ion-icon>
                            </i>
                        </div>
                        <ErrorMessage name="meeting_location" class="error-feedback" />
                    </div>
                    <div class="transparent pt-3" v-if="responseData.permissions.update_details">
                        <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="btnLoading">
                            <span v-show="btnLoading" class="spinner-border spinner-border-sm"></span>
                            <span>{{ $t('save') }}</span>
                        </button>
                    </div>
                </div>

            </div>
        </Form>
    </div>
    <!-- <div class="section" v-if="!loading && tabA">
        <div class="wallet-card mt-1">
        <p> <b class="text-primary">വിസ്ഡം ഡേ പ്രോഗ്രാം</b> <br>
            <b class="text-primary">സ്വാഗതം :</b>  സെക്രട്ടറി, വിസ്ഡം യൂത്ത് <br>
            <b class="text-primary">അധ്യക്ഷന്‍ :</b>  പ്രസിഡണ്ട്, മാതൃ ഘടകം<br>
                <b class="text-primary">മിനുട്‌സ്, റിപ്പോര്‍ട്ട്, കണക്ക് അവതരണം :</b>  ഓരോ ഘടകത്തിന്റെയും സെക്രട്ടറിമാര്‍ <br>
                    <b class="text-primary">വീഡിയോ അവതരണം</b> <br>
                        <b class="text-primary">സര്‍ക്കുലര്‍ വിശദീകരണം & ചര്‍ച്ച :</b>  സെക്രട്ടറി, മാതൃ ഘടകം <br>
                            <b class="text-primary">പാഠക്കുറിപ്പ് അവതരണം :</b> ചുമതലപ്പെടുത്തുന്ന ശാഖാ ഭാരവാഹി <br>
                                <b class="text-primary">നന്ദി :</b> സെക്രട്ടറി, സ്റ്റുഡന്റ്‌സ്</p>
                            </div>
    </div> -->
    <ul class="listview image-listview inset text mt-1" v-if="!loading && tabA">
        <li>
            <a href="javascript:void(0)" class="item">
                <span class="sl-no"></span>
                <div class="in">
                    <div class="min-width-50">
                        <header></header>
                        <b>{{ responseData.heading.agenda }}</b>
                        <footer> </footer>
                    </div>
                    <div class="card-button" v-if="responseData.permissions.update_agenda">
                        <button type="button" class="btn btn-icon btn-primary me-1" @click="showAddAgendaModal">
                            <ion-icon name="add-outline" class="md hydrated"></ion-icon>
                        </button>
                    </div>
                </div>
            </a>
        </li>
        <li v-for="(agenda, index) in responseData.agenda" v-bind:key="agenda.id">
            <a href="javascript:void(0)" class="item">
                <span class="sl-no">{{ index + 1 }}.</span>
                &nbsp;&nbsp;
                <div class="in">
                    <div class="min-width-50">
                        <!-- <header>User</header> -->
                        <b class="mal-text"> {{ agenda.agenda }} </b>
                        <footer class="text-primary" v-if="agenda.assigned_member_name">{{
                            agenda.assigned_member_name
                        }}</footer>
                    </div>
                    <div class="card-button dropdown" v-if="responseData.permissions.update_agenda">
                        <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                            :data-bs-target="'#actionSheetInset' + agenda.id" @click="showActionModel">
                            <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                        </button>
                    </div>

                    <!-- Default Action Sheet Inset -->
                    <div class="modal fade action-sheet" :id="'actionSheetInset' + agenda.id" tabindex="-1" role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">{{ $t('action') }}</h5>
                                </div>
                                <div class="modal-body">
                                    <ul class="action-button-list">
                                        <li>
                                            <a href="javascript:void(0)" class="btn btn-list"
                                                @click="showAddAgendaModal(agenda)" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="create-outline"></ion-icon> {{ $t('edit') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0)" class="btn btn-list"
                                                @click="deleteAgendaConfirmation(agenda)" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="trash-outline"></ion-icon> {{ $t('remove') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li class="action-divider"></li>
                                        <li>
                                            <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="close-outline"></ion-icon> {{ $t('cancel') }}
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- * Default Action Sheet Inset -->
                </div>
            </a>
        </li>
    </ul>
    <div v-if="!loading && tabM">
        <div class="section mt-1">
            <ul class="nav nav-tabs capsuled" role="tablist">
                <li class="nav-item" v-if="responseData.permissions.view_questians">
                    <a class="nav-link" v-bind:class="responseData.permissions.view_questians ? 'active' : ''"
                        data-bs-toggle="tab" href="javascript:void(0)" role="tab" @click="goToMinutesTab('tabMQ')">
                        {{ $t('questionnaire') }}
                    </a>
                </li>
                <li class="nav-item" v-if="responseData.permissions.view_custom_minutes">
                    <a class="nav-link" v-bind:class="responseData.permissions.view_questians ? '' : 'active'"
                        data-bs-toggle="tab" href="javascript:void(0)" role="tab" @click="goToMinutesTab('tabMM')">
                        {{ $t('minutes') }}
                    </a>
                </li>
            </ul>
        </div>
        <div class="section text-center mt-1" v-if="minutes_loading">
            <div class="spinner-border text-primary" role="status"></div>
        </div>
        <div class="section mt-1" v-if="!minutes_loading && tabMQ && responseData.permissions.view_questians">
            <Form @submit="saveQuestianair" :validation-schema="questianair_schema">
                <div class="card">
                    <div class="card-body">
                        <div class="form-group basic" v-for="(questian, index) in responseData.questians"
                            v-bind:key="questian.id">
                            <div class="input-wrapper">
                                <label class="label questians-label" :for="'field' + questian.id"><b>{{ index + 1 }}. {{
                                    questian.questian.question_text
                                }}</b></label>
                                <Field type="text" class="form-control" :name="'questian_air[' + index + ']'"
                                    placeholder="..." v-model="questians_responses[index]"
                                    :required="questian.questian.question_validations == 'Y'" />
                                <i class="clear-input">
                                    <ion-icon name="close-circle"></ion-icon>
                                </i>
                            </div>
                        </div>
                        <div class="form-group basic">
                            <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="btnLoading"
                                v-if="responseData.permissions.update_minutes">
                                <span v-show="btnLoading" class="spinner-border spinner-border-sm"></span>
                                <span>{{ $t('save') }}</span></button>
                            <button type="button" class="btn btn-primary btn-block btn-lg"
                                v-if="!responseData.permissions.update_minutes" @click="closeAddMinutesModal">{{ $t('close') }}</button>
                        </div>

                    </div>
                </div>
            </Form>
        </div>
        <div class="section mt-1" v-if="!minutes_loading && tabMM && responseData.permissions.update_minutes">
            <div class="card">
                <div class="card-body">
                    <div class="input-wrapper">
                        <label class="label">Upload Minutes</label>
                        <input type="file" ref="fileInput" class="form-control" @change="uploadMinuteFile" accept=".pdf,.jpg,.jpeg" multiple>
                        <small class="form-text text-muted" v-if="selectedFilesCount > 0">
                            {{ selectedFilesCount }} file(s) selected
                        </small>
                    </div>
                </div>
            </div>
        </div>
        <!-- Uploaded Files Section -->
        <ul class="listview image-listview inset text mt-1" v-if="!minutes_loading && tabMM && uploadedFiles.length > 0">
            <li>
                <a href="javascript:void(0)" class="item">
                    <span class="sl-no"></span>
                    <div class="in">
                        <div class="min-width-50">
                            <header></header>
                            <b>Uploaded Files</b>
                            <footer> </footer>
                        </div>
                    </div>
                </a>
            </li>
            <li v-for="(minutes, index) in uploadedFiles" v-bind:key="minutes.id">
                <a href="javascript:void(0)" class="item">
                    <span class="sl-no">{{ index + 1 }}.</span>
                    &nbsp;&nbsp;
                    <div class="in">
                        <div class="min-width-50">
                            <b class="mal-text"> {{ minutes.minutes || minutes.file_name || 'Minutes Document' }} </b>
                            <footer class="text-primary" v-if="minutes.assigned_member_name">{{
                                minutes.assigned_member_name
                            }}</footer>
                            <footer v-if="minutes.due_date" class="text-muted" style="font-size: 0.85rem;">
                                {{ 'Due Date' }}: {{ formatDate(minutes.due_date) }}
                            </footer>
                            <footer v-if="minutes.status" class="text-muted" style="font-size: 0.85rem;">
                                {{ $t('status') }}: <span :style="getStatusColor(minutes.status)">{{ minutes.status }}</span>
                            </footer>
                            <footer v-if="minutes.notes" class="text-muted" style="font-size: 0.85rem; margin-top: 4px; font-style: italic;">
                                <strong>{{ $t('remarks') || 'Remarks' }}:</strong> {{ minutes.notes }}
                            </footer>
                        </div>
                        <div class="card-button dropdown" v-if="responseData.permissions.update_minutes">
                            <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                                :data-bs-target="'#actionSheetInsetFile' + minutes.id" @click="showActionModel">
                                <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                            </button>
                        </div>

                        <!-- Default Action Sheet Inset for Files -->
                        <div class="modal fade action-sheet" :id="'actionSheetInsetFile' + minutes.id" tabindex="-1"
                            role="dialog">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">{{ $t('action') }}</h5>
                                    </div>
                                    <div class="modal-body">
                                        <ul class="action-button-list">
                                            <li v-if="minutes.file">
                                                <a href="javascript:void(0)" @click="viewFile(minutes.file, minutes.file_name)" class="btn btn-list" data-bs-dismiss="modal">
                                                    <span>
                                                        <ion-icon name="document-text-outline"></ion-icon> {{ minutes.file_name || 'View File' }}
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)" class="btn btn-list"
                                                    @click="deleteMinutesConfirmation(minutes)" data-bs-dismiss="modal">
                                                    <span>
                                                        <ion-icon name="trash-outline"></ion-icon> {{ $t('remove') }}
                                                    </span>
                                                </a>
                                            </li>
                                            <li class="action-divider"></li>
                                            <li>
                                                <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                                    <span>
                                                        <ion-icon name="close-outline"></ion-icon> {{ $t('cancel') }}
                                                    </span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- * Default Action Sheet Inset -->
                    </div>
                </a>
            </li>
        </ul>
        
        <!-- Meeting Decisions (without files) -->
        <ul class="listview image-listview inset text mt-1" v-if="!minutes_loading && tabMM">
            <li>
                <a href="javascript:void(0)" class="item">
                    <span class="sl-no"></span>
                    <div class="in">
                        <div class="min-width-50">
                            <header></header>
                            <b>{{ $t('meeting_minutes') }}</b>
                            <footer> </footer>
                        </div>
                        <div class="card-button d-flex align-items-center">
                            <button
                                type="button"
                                class="btn btn-icon btn-outline-primary me-1"
                                @click="downloadMeetingDecisionsPdf"
                                :disabled="decisionsPdfDownloading"
                                title="Download PDF">
                                <ion-icon v-if="!decisionsPdfDownloading" name="document-text-outline" class="md hydrated"></ion-icon>
                                <span v-else class="spinner-border spinner-border-sm" role="status"></span>
                            </button>
                            <button
                                v-if="responseData.permissions.update_minutes"
                                type="button"
                                class="btn btn-icon btn-primary me-1"
                                @click="showAddMinutesModal">
                                <ion-icon name="add-outline" class="md hydrated"></ion-icon>
                            </button>
                        </div>
                    </div>
                </a>
            </li>
            <li v-for="(minutes, index) in minutesWithoutFiles" v-bind:key="minutes.id">
                <a href="javascript:void(0)" class="item">
                    <span class="sl-no">{{ index + 1 }}.</span>
                    &nbsp;&nbsp;
                    <div class="in">
                        <div class="min-width-50">
                            <!-- <header>User</header> -->
                            <b class="mal-text"> {{ minutes.minutes }} </b>
                            <footer class="text-primary" v-if="minutes.assigned_member_name">{{
                                minutes.assigned_member_name
                            }}</footer>
                            <footer v-if="minutes.due_date" class="text-muted" style="font-size: 0.85rem;">
                                {{ 'Due Date' }}: {{ formatDate(minutes.due_date) }}
                            </footer>
                            <footer v-if="minutes.status" class="text-muted" style="font-size: 0.85rem;">
                                {{ $t('status') }}: <span :style="getStatusColor(minutes.status)">{{ minutes.status }}</span>
                            </footer>
                            <footer v-if="minutes.notes" class="text-muted" style="font-size: 0.85rem; margin-top: 4px; font-style: italic;">
                                <strong>{{ $t('remarks') || 'Remarks' }}:</strong> {{ minutes.notes }}
                            </footer>
                        </div>
                        <div class="card-button dropdown" v-if="responseData.permissions.update_minutes">
                            <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                                :data-bs-target="'#actionSheetInset' + minutes.id" @click="showActionModel">
                                <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                            </button>
                        </div>

                        <!-- Default Action Sheet Inset -->
                        <div class="modal fade action-sheet" :id="'actionSheetInset' + minutes.id" tabindex="-1"
                            role="dialog">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">{{ $t('action') }}</h5>
                                    </div>
                                    <div class="modal-body">
                                        <ul class="action-button-list">
                                            <li>
                                                <a href="javascript:void(0)" class="btn btn-list"
                                                    @click="showAddMinutesModal(minutes)" data-bs-dismiss="modal">
                                                    <span>
                                                        <ion-icon name="create-outline"></ion-icon> {{ $t('edit') }}
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)" class="btn btn-list"
                                                    @click="deleteMinutesConfirmation(minutes)" data-bs-dismiss="modal">
                                                    <span>
                                                        <ion-icon name="trash-outline"></ion-icon> {{ $t('remove') }}
                                                    </span>
                                                </a>
                                            </li>
                                            <li class="action-divider"></li>
                                            <li>
                                                <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                                    <span>
                                                        <ion-icon name="close-outline"></ion-icon> {{ $t('cancel') }}
                                                    </span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- * Default Action Sheet Inset -->
                    </div>
                </a>
            </li>
        </ul>
    </div>
    <ul class="listview image-listview inset text mt-1" v-if="!loading && tabH">
        <li>
            <a href="javascript:void(0)" class="item">
                <span class="sl-no"></span>
                <div class="in">
                    <div class="min-width-50">
                        <header></header>
                        <b>{{ responseData.heading.history }}</b>
                        <footer> </footer>
                    </div>
                    <div class="card-button" v-if="responseData.permissions.update_history">
                        <button type="button" class="btn btn-icon btn-primary me-1" @click="showAddHistoryModal">
                            <ion-icon name="add-outline" class="md hydrated"></ion-icon>
                        </button>
                    </div>
                </div>
            </a>
        </li>
        <li v-for="(history, index) in responseData.history" v-bind:key="history.id">
            <a href="javascript:void(0)" class="item">
                <span class="sl-no">{{ index + 1 }}.</span>
                &nbsp;&nbsp;
                <div class="in">
                    <div class="min-width-50">
                        <!-- <header>User</header> -->
                        <b class="mal-text"> {{ history.text }} </b>
                        <footer></footer>
                    </div>
                    <div class="card-button dropdown" v-if="responseData.permissions.update_history">
                        <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                            :data-bs-target="'#actionSheetInset' + history.id" @click="showActionModel">
                            <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                        </button>
                    </div>

                    <!-- Default Action Sheet Inset -->
                    <div class="modal fade action-sheet" :id="'actionSheetInset' + history.id" tabindex="-1" role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">{{ $t('action') }}</h5>
                                </div>
                                <div class="modal-body">
                                    <ul class="action-button-list">
                                        <li>
                                            <a href="javascript:void(0)" class="btn btn-list"
                                                @click="showAddHistoryModal(history)" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="create-outline"></ion-icon> {{ $t('edit') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0)" class="btn btn-list"
                                                @click="deleteHistoryConfirmation(history)" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="trash-outline"></ion-icon> {{ $t('remove') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li class="action-divider"></li>
                                        <li>
                                            <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="close-outline"></ion-icon> {{ $t('cancel') }}
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- * Default Action Sheet Inset -->
                </div>
            </a>
        </li>
    </ul>
    <div class="section mt-1 mb-2" v-if="!loading && tabH">
        <!-- <div class="section-title">with Time Labels</div> -->
        <div class="card">
            <!-- timeline -->
            <div class="timeline timed ms-1 me-2">
                <div class="item" v-for="history in responseData.meeting_history" v-bind:key="history.id">
                    <span class="time">{{ history.time }}</span>
                    <div class="dot bg-primary"></div>
                    <div class="content">
                        <h4 class="title">{{ history.added_by_name }}</h4>
                        <div class="text">{{ history.text }}</div>
                    </div>
                </div>
            </div>
            <!-- * timeline -->
        </div>
    </div>

    <!-- AddAgendaModel -->
    <div class="modal fade action-sheet" id="addAgendaModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ responseData.heading.agenda }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <Form @submit="saveAgenda" :validation-schema="agenda_schema">
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="name"><span>{{
                                        responseData.heading.agenda
                                    }}</span></label>
                                    <Field name="agenda" type="text" class="form-control" v-model="agenda"
                                        :placeholder="responseData.heading.agenda" autocomplete="off" />
                                </div>
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="agenda_assigned_member">{{ $t('assigned_member') }}</label>
                                    <v-select
                                        id="agenda_assigned_member"
                                        class="assigned-member-select"
                                        multiple
                                        :close-on-select="false"
                                        label="text"
                                        :reduce="option => option.value"
                                        v-model="agenda_assigned_member"
                                        :options="participantMemberOptions"
                                        :placeholder="$t('select_member')"
                                    />
                                </div>
                            </div>
                            <div class="form-group basic">
                                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="btnLoading"
                                    v-if="responseData.permissions.update_agenda">
                                    <span v-show="btnLoading" class="spinner-border spinner-border-sm"></span>
                                    <span>{{ $t('save') }}</span></button>
                                <button type="button" class="btn btn-primary btn-block btn-lg"
                                    v-if="!responseData.permissions.update_agenda"
                                    @click="closeAddAgendaModal">{{ $t('close') }}</button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- AddAgendaModel -->

    <!-- AddMinutesModel -->
    <div class="modal fade action-sheet" id="addMinutesModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('minutes') }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <Form @submit="saveMinutes" :validation-schema="minutes_schema">
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="minutes"><span>{{ $t('minutes') }}</span></label>
                                    <Field name="minutes" type="text" class="form-control" v-model="minutes"
                                        placeholder="തീരുമാനങ്ങൾ ടൈപ്പ് ചെയ്യുക" autocomplete="off" />
                                </div>
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="minutes_assigned_member">{{ $t('assigned_member') }}</label>
                                    <v-select
                                        id="minutes_assigned_member"
                                        class="assigned-member-select"
                                        multiple
                                        :close-on-select="false"
                                        label="text"
                                        :reduce="option => option.value"
                                        v-model="minutes_assigned_member"
                                        :options="participantMemberOptions"
                                        :placeholder="$t('select_member')"
                                        @input="onMinutesAssignedMemberChange"
                                    />
                                </div>
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="minutes_due_date">Due Date</label>
                                    <Field type="date" class="form-control" id="minutes_due_date"
                                        name="minutes_due_date" v-model="minutes_due_date" />
                                </div>
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="minutes_status">Status</label>
                                    <Field as="select" class="form-control" id="minutes_status"
                                        name="minutes_status" v-model="minutes_status">
                                        <option value>Select Status</option>
                                        <option value="Assigned">Assigned</option>
                                        <option value="In Progress">In Progress</option>
                                        <option value="On Hold">On Hold</option>
                                        <option value="Completed">Completed</option>
                                    </Field>
                                </div>
                            </div>

                            <!-- Show remarks field only when editing -->
                            <div class="form-group basic" v-if="editable_id">
                                <div class="input-wrapper">
                                    <label class="label" for="minutes_notes">{{ $t('remarks') || 'Remarks' }}</label>
                                    <Field as="textarea" class="form-control" id="minutes_notes"
                                        name="minutes_notes" v-model="minutes_notes"
                                        :placeholder="$t('enter_remarks') || 'Enter remarks or notes...'"
                                        rows="3"></Field>
                                </div>
                            </div>

                            <div class="form-group basic">
                                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="btnLoading"
                                    v-if="responseData.permissions.update_minutes">
                                    <span v-show="btnLoading" class="spinner-border spinner-border-sm"></span>
                                    <span>{{ $t('save') }}</span></button>
                                <button type="button" class="btn btn-primary btn-block btn-lg"
                                    v-if="!responseData.permissions.update_minutes"
                                    @click="closeAddMinutesModal">{{ $t('close') }}</button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- AddMinutesModel -->

    <!-- attendanceModel -->
    <div class="modal fade action-sheet" id="attendanceModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('meeting_attendance') }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div class="form-group" v-if="attendance_message">
                            <div v-if="attendance_message" class="error-feedback">
                                {{ attendance_message }}
                            </div>
                        </div>
                        <div class="form-group basic">
                            <label class="label" for="stay"><span>{{ $t('attendance') }}</span></label>
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <select as="select" class="form-control custom-select" v-model="attendance"
                                        name="attendance" id="select4">
                                        <option value="P">{{ $t('present') }}</option>
                                        <option value="A">{{ $t('absent') }}</option>
                                        <option value="L">{{ $t('leave') }}</option>
                                    </select>
                                </div>
                                <input type="hidden" v-model="member_id" />
                            </div>
                        </div>
                        <div class="form-group basic" v-if="attendance == 'A' || attendance == 'L'">
                            <label class="label" for="stay"><span>{{ $t('remarks') }}</span></label>
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <div class="form-group boxed">
                                        <input name="attendance_remarks" type="text" class="form-control"
                                            v-model="attendance_remarks" placeholder="Remarks" autocomplete="off" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group basic">
                            <button type="button" @click="markAttandance()" class="btn btn-primary btn-block btn-lg"
                                :disabled="loading">
                                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                <span>{{ $t('save') }}</span></button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <!-- AddMinutesModel -->
    <div class="modal fade action-sheet" id="addHistoryModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title"> {{ responseData.heading.history }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <Form @submit="saveHistory" :validation-schema="history_schema">
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="text"><span>{{ $t('text') }}</span></label>
                                    <Field name="text" type="text" class="form-control" v-model="text" placeholder="Text"
                                        autocomplete="off" required />
                                </div>
                            </div>
                            <div class="form-group basic">
                                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="btnLoading"
                                    v-if="responseData.permissions.update_history">
                                    <span v-show="btnLoading" class="spinner-border spinner-border-sm"></span>
                                    <span>{{ $t('save') }}</span></button>
                                <button type="button" class="btn btn-primary btn-block btn-lg"
                                    v-if="!responseData.permissions.update_history"
                                    @click="closeAddHistroyModal">{{ $t('close') }}</button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- AddMinutesModel -->
    <!-- AddParticipantModel -->
    <div class="modal fade action-sheet" id="addParticipantModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ responseData.heading.participants }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <Form @submit="saveParticipant" :validation-schema="participant_schema">
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="participant">{{ $t('members') }}</label>
                                    <v-select label="text" :filterable="true" v-model="participant" :value="participant"
                                        :options="member_list" @input="getTextList($event.target.value, 'all')">
                                        <template>
                                            {{ $t('search') }}
                                        </template>
                                        <template>
                                            <div class="d-center">
                                                {{ participant.name }}
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                                <div class="input-info" v-if="participant">{{ $t('mobile_number')}} :{{ participant.country_code }} {{
                                    participant.mobile
                                }}
                                </div>
                            </div>
                            <div class="form-group basic">
                                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="btnLoading"
                                    v-if="responseData.permissions.update_participants">
                                    <span v-show="btnLoading" class="spinner-border spinner-border-sm"></span>
                                    <span>{{ $t('save') }}</span></button>
                                <button type="button" class="btn btn-primary btn-block btn-lg"
                                    v-if="!responseData.permissions.update_participants"
                                    @click="closeAddAgendaModal">{{ $t('close') }}</button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- AddParticipantModel -->
    
    <!-- File Viewer Modal -->
    <div class="modal fade" id="fileViewerModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-fullscreen" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ viewerFileName }}</h5>
                    <button type="button" class="btn-close" @click="closeFileViewer" aria-label="Close"></button>
                </div>
                <div class="modal-body p-0" style="height: calc(100vh - 120px); overflow: auto;">
                    <iframe v-if="viewerFile" :src="viewerFile" style="width: 100%; height: 100%; border: none;"></iframe>
                </div>
            </div>
        </div>
    </div>
    <!-- * File Viewer Modal -->
    
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
</template>
<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import UserService from "../../services/user.service";
import AlertModel from "../layouts/AlertModel.vue";
import DialogModel from "../layouts/DialogModel.vue";
import vSelect from 'vue-select'
import $ from 'jquery';
export default {
    name: 'Organization',
    components: {
        Form,
        Field,
        vSelect,
        ErrorMessage,
        AlertModel,
        DialogModel
    },
    data() {
        return {
            loading: false,
            minutes_loading: false,
            btnLoading: false,
            selectedFilesCount: 0,
            participant: [],
            member_list: [],
            alert_type: '',
            alert_message: '',
            dialog_message: '',
            dialog_action: '',
            dialog_action_params: [],
            tabD: true,
            tabP: false,
            tabA: false,
            tabM: false,
            tabH: false,
            tabMQ: false,
            tabMM: true,
            responseData: {
                meeting: [],
                participants: [],
                agenda: [],
                minutes: [],
                permissions: [],
                questians: [],
                heading: [],
                participant_details: []
            },
            meeting_id: '',
            meeting_location: '',
            meeting_date: '',
            meeting_time: '',
            meeting_mode: '',
            text: '',
            agenda: '',
            minutes: '',
            editable_id: '',
            attendance: 'A',
            attendance_remarks: '',
            message: "",
            user_level: "",
            permissions: [],
            sub_levels: [],
            sub_level_list_name: "",
            user_level_id: "",
            unit: [],
            nerpatham_target: '',
            sub_level_id: '',
            sub_level: [],
            questians_responses: [],
            agenda_assigned_member: [],
            minutes_assigned_member: [],
            minutes_due_date: '',
            minutes_status: '',
            minutes_notes: '',
            minutes_file: null,
            upload_minutes_assigned_member: '',
            upload_minutes_due_date: '',
            upload_minutes_status: '',
            upload_minutes_file: null,
            self_attendance_btn: false,
            self_coming_btn: false,
            search_qty: '',
            filter_attendance:'All',
            filter_district_id: '',
            filter_zone_id: '',
            filter_unit_id: '',
            district_list: [],
            zone_list: [],
            unit_list: [],
            agenda_schema: null,
            minutes_schema: null,
            history_schema: null,
            participant_schema: null,
            questianair_schema: null,
            attendance_message: '',
            member_id: '',
            viewerFile: null,
            viewerFileName: '',
            decisionsPdfDownloading: false,
            markingAttendanceIds: [],
            bulkMarkingAttendance: false
        };
    },

    computed: {
        pageParticipants() {
            const participants = this.responseData.participants && this.responseData.participants.data
                ? this.responseData.participants.data
                : [];
            return participants.filter((p) => p.member);
        },
        hasUnmarkedParticipants() {
            return this.pageParticipants.some((p) => p.attendance !== 'P');
        },
        allPageParticipantsPresent() {
            return this.pageParticipants.length > 0
                && this.pageParticipants.every((p) => p.attendance === 'P');
        },
        // Attendance can only be taken on the meeting's own date, not before or after.
        isMeetingToday() {
            const meetingDate = this.responseData && this.responseData.meeting && this.responseData.meeting.meeting_date;
            if (!meetingDate) return false;
            const today = new Date();
            const todayStr = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');
            return meetingDate === todayStr;
        },
        participantMemberOptions() {
            const list = this.responseData.participants?.data || [];
            return list
                .map((participant) => ({
                    value: participant.member_id,
                    text: participant.member ? participant.member.name : ''
                }))
                .filter((option) => option.value);
        },
        currentUser() {
            return this.$store.state.auth.user;
        },
        isStateAdmin() {
            return this.user_level == 1;
        },
        isDistrictAdmin() {
            return this.user_level == 2;
        },
        hasActiveParticipantFilters() {
            return !!(this.filter_district_id || this.filter_zone_id || this.filter_unit_id);
        },
        participantsWithAttendance() {
            if (!this.responseData.participants) {
                return 0;
            }
            
            // Check if participants is an array or paginated object
            const participantsData = Array.isArray(this.responseData.participants) 
                ? this.responseData.participants 
                : (this.responseData.participants.data || []);
            
            if (!participantsData || participantsData.length === 0) {
                return 0;
            }
            
            // Count participants who have marked attendance (P, A, or L, but not N or empty)
            const count = participantsData.filter(participant => {
                return participant.attendance && 
                       participant.attendance !== 'N' && 
                       participant.attendance !== '' && 
                       participant.attendance !== null;
            }).length;
            
            return count;
        },
        minutesWithoutFiles() {
            if (!this.responseData.minutes || !Array.isArray(this.responseData.minutes)) {
                return [];
            }
            return this.responseData.minutes
                .filter(minutes => !minutes.file)
                .sort((a, b) => (Number(a.id) || 0) - (Number(b.id) || 0));
        },
        uploadedFiles() {
            if (!this.responseData.minutes || !Array.isArray(this.responseData.minutes)) {
                return [];
            }
            return this.responseData.minutes
                .filter(minutes => minutes.file)
                .sort((a, b) => (Number(a.id) || 0) - (Number(b.id) || 0));
        }
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.meeting_id = this.$route.params.id;
            this.user_level = this.currentUser.user_level;
            this.$root.updateParent("Loading...");
            if (this.user_level == 1) {
                this.user_level_id = 0;
                this.fetchFilterDistricts();
            } else if (this.user_level == 2) {
                this.user_level_id = this.currentUser.district_id;
                this.filter_district_id = this.currentUser.district_id ? String(this.currentUser.district_id) : '';
                this.fetchFilterZones(this.filter_district_id);
            }
            else if (this.user_level == 3) {
                this.user_level_id = this.currentUser.zone_id;
            }
            else if (this.user_level == 4) {
                this.user_level_id = this.currentUser.unit_id;
            }
            this.getMeetings(1, 'Details');
        }
    },
    methods: {
        goToTab(tab) {
            this.loading = true;
            this.tabD = false;
            this.tabP = false;
            this.tabA = false;
            this.tabM = false;
            this.tabH = false;
            if (tab == 'tabD') {
                this.tabD = true;
                // this.getMeetings('Details');
                this.loading = false;
            } else if (tab == 'tabP') {
                this.tabP = true;
                // this.getMeetings('Participants');
                this.loading = false;
            } else if (tab == 'tabA') {
                this.tabA = true;
                // this.getMeetings('Agenda');
                this.loading = false;
            } else if (tab == 'tabM') {
                this.tabM = true;
                // this.getMeetings('Minutes');
                this.loading = false;
            } else {
                this.tabH = true;
                // this.getMeetings('Minutes');
                this.loading = false;
            }
        },
        goToMinutesTab(tab) {
            this.minutes_loading = true;
            this.tabMM = false;
            this.tabMQ = false;
            if (tab == 'tabMM') {
                this.tabMM = true;
                this.minutes_loading = false;
            } else {
                this.tabMQ = true;
                this.minutes_loading = false;
            }
        },
        getTextList(event, type) {
            this.message = '';
            let data = {
                q: event,
                type: type,
                filter: 'all',
                user_level: 1
            }
            UserService.authPostRequest('get-typehead-values', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.member_list = response.data.data.list;
                    }
                },
                (error) => {
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getMeetings(page = 1, type = 'Details',filter_attendance = null) {
            this.loading = true;
            this.filter_attendance = filter_attendance ? filter_attendance : this.filter_attendance;
            let data = {
                type: type,
                meeting_id: this.meeting_id,
                search_qty: this.search_qty,
                filter_attendance: this.filter_attendance,
                district_id: this.filter_district_id || undefined,
                zone_id: this.filter_zone_id || undefined,
                unit_id: this.filter_unit_id || undefined
            };
            UserService.authPostRequest(`get-meeting-detail?page=${page}`, data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.loading = false;
                        this.responseData = response.data.data;
                        this.meeting_date = this.responseData.meeting.meeting_date;
                        this.meeting_time = this.responseData.meeting.meeting_time;
                        this.meeting_mode = this.responseData.meeting.meeting_mode;
                        this.meeting_location = this.responseData.meeting.meeting_location;
                        if (this.responseData.questians) {
                            this.tabMQ = true;
                            let count = 0;
                            this.responseData.questians.forEach(element => {
                                this.questians_responses[count] = element.answer_text;
                                count++;
                            });
                        }
                        if (this.responseData.participant_details.attendance == 'P') {
                            this.self_attendance_btn = true;
                        }
                        if (this.responseData.participant_details.coming_status == 'P') {
                            this.self_coming_btn = true;
                        }
                        this.$root.updateParent('Meeting Dashboard');
                    } else {
                        this.loading = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = 'Error';
                    this.alert_message = error.data.message;
                    this.$refs.alert_model.openModel();
                }
            );
        },
        async fetchFilterDistricts() {
            try {
                const response = await UserService.authPostRequest('get-district-by-id', {});
                this.district_list = (response.data && response.data.data && response.data.data.list) || [];
                if (!Array.isArray(this.district_list)) this.district_list = [];
            } catch (e) {
                this.district_list = [];
            }
        },
        async fetchFilterZones(districtId) {
            if (!districtId) {
                this.zone_list = [];
                return;
            }
            try {
                const response = await UserService.authPostRequest('get-zone-by-id', { district_id: parseInt(districtId) });
                this.zone_list = (response.data && response.data.data && response.data.data.list) || [];
                if (!Array.isArray(this.zone_list)) this.zone_list = [];
            } catch (e) {
                this.zone_list = [];
            }
        },
        async fetchFilterUnits(zoneId) {
            if (!zoneId) {
                this.unit_list = [];
                return;
            }
            try {
                const response = await UserService.authPostRequest('get-unit-by-id', { zone_id: parseInt(zoneId) });
                this.unit_list = (response.data && response.data.data && response.data.data.list) || [];
                if (!Array.isArray(this.unit_list)) this.unit_list = [];
            } catch (e) {
                this.unit_list = [];
            }
        },
        onFilterDistrictChange() {
            this.filter_zone_id = '';
            this.filter_unit_id = '';
            this.zone_list = [];
            this.unit_list = [];
            if (this.filter_district_id) {
                this.fetchFilterZones(this.filter_district_id).then(() => {
                    this.getMeetings(1, 'Details');
                });
            } else {
                this.getMeetings(1, 'Details');
            }
        },
        onFilterZoneChange() {
            this.filter_unit_id = '';
            this.unit_list = [];
            this.fetchFilterUnits(this.filter_zone_id).then(() => {
                this.getMeetings(1, 'Details');
            });
        },
        onFilterUnitChange() {
            this.getMeetings(1, 'Details');
        },
        clickSublevel(sub_level_id) {
            this.$router.push('/level-2-org/' + (this.user_level + 1) + '/' + sub_level_id);
        },
        nerpathamTarget(sub_level = null) {
            this.nerpatham_target = sub_level.nerpatham_target;
            this.sub_level_id = sub_level.id;
            $('#nerpathamTargetModel').modal('show');
        },
        wisdomDayDate(day) {
            const year = this.responseData.meeting.meeting_year || new Date().getFullYear();
            return `${year}-08-${String(day).padStart(2, '0')}`;
        },
        meetingDetailSave(data) {
            this.btnLoading = true;
            data.meeting_id = this.meeting_id;
            UserService.addAdmin('update-meeting-detail', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.responseData = response.data.data;
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btnLoading = false;
                        this.message = '';
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btnLoading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btnLoading = false;
                    } else {
                        this.btnLoading = false;
                    }
                },
                (error) => {
                    this.alert_type = 'Error';
                    this.alert_message = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                    this.$refs.alert_model.openModel();
                    this.btnLoading = false;
                }
            );
        },
        showAddAgendaModal(agenda = null) {
            this.agenda = '';
            this.agenda_assigned_member = [];
            this.editable_id = '';
            if (agenda) {
                this.agenda = agenda.agenda;
                this.agenda_assigned_member = this.parseAssignedMemberIds(agenda.assigned_member);
                this.editable_id = agenda.id;
            }
            $('#addAgendaModel').modal('show');
        },
        closeAddAgendaModal() {
            $('#addAgendaModel').modal('hide');
        },
        saveAgenda(agenda) {
            this.btnLoading = true;
            agenda.meeting_id = this.meeting_id;
            agenda.editable_id = this.editable_id;
            agenda.agenda_assigned_member = this.formatAssignedMemberForApi(this.agenda_assigned_member);

            UserService.authPostRequest('store-agenda', agenda).then(
                (response) => {
                    if (response.data.status == 'success') {
                        $('#addAgendaModel').modal('hide');
                        this.responseData = response.data.data;
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btnLoading = false;
                        this.message = '';
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btnLoading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btnLoading = false;
                    } else {
                        this.btnLoading = false;
                    }
                },
                (error) => {
                    this.alert_type = 'Error';
                    this.alert_message = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                    this.$refs.alert_model.openModel();
                    this.btnLoading = false;
                }
            );
        },
        deleteAgendaConfirmation(agenda) {
            var data = {
                editable_id: agenda.id,
                meeting_id: this.meeting_id
            }
            this.dialog_action_params = data;
            this.dialog_message = 'ശരിക്കും ഡിലീറ്റ് ചെയ്യണോ?';
            this.dialog_action = 'deleteAgenda';
            this.$refs.dialog_model.openModel();
            this.loading = false;
        },
        deleteAgenda(data) {
            UserService.authPostRequest('delete-agenda', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.responseData = response.data.data;
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },

        showAddMinutesModal(minutes = null) {
            this.minutes = '';
            this.minutes_assigned_member = [];
            this.minutes_due_date = '';
            this.minutes_status = '';
            this.minutes_notes = '';
            this.editable_id = '';
            if (minutes) {
                this.minutes = minutes.minutes;
                this.minutes_assigned_member = this.parseAssignedMemberIds(minutes.assigned_member);
                this.minutes_due_date = minutes.due_date || '';
                this.minutes_status = minutes.status || '';
                this.minutes_notes = minutes.notes || '';
                this.editable_id = minutes.id;
                // If member is assigned but status is not set, auto-set to "Assigned"
                if (this.minutes_assigned_member.length && !this.minutes_status) {
                    this.minutes_status = 'Assigned';
                }
            }
            $('#addMinutesModel').modal('show');
        },
        parseAssignedMemberIds(value) {
            if (!value) {
                return [];
            }
            if (Array.isArray(value)) {
                return value.map((id) => parseInt(id, 10)).filter((id) => id > 0);
            }
            return String(value)
                .split(',')
                .map((id) => parseInt(id.trim(), 10))
                .filter((id) => id > 0);
        },
        formatAssignedMemberForApi(value) {
            const ids = this.parseAssignedMemberIds(value);
            return ids.length ? ids.join(',') : null;
        },
        onMinutesAssignedMemberChange() {
            // Automatically set status to "Assigned" when a member is assigned
            if (this.minutes_assigned_member.length && !this.minutes_status) {
                this.minutes_status = 'Assigned';
            }
        },
        closeAddMinutesModal() {
            $('#addMinutesModel').modal('hide');
        },
        uploadMinuteFile(e) {
            const files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                this.selectedFilesCount = 0;
                return;
            }

            // Update selected files count
            this.selectedFilesCount = files.length;

            this.minutes_loading = true;
            const totalFiles = files.length;
            let uploadedCount = 0;
            let failedCount = 0;
            const errors = [];

            // Upload files sequentially
            const uploadNext = (index) => {
                if (index >= totalFiles) {
                    // All files processed
                    this.minutes_loading = false;
                    
                    // Reset input and count
                    e.target.value = '';
                    this.selectedFilesCount = 0;
                    
                    // Show summary message
                    if (failedCount === 0) {
                        this.alert_type = 'Success';
                        this.alert_message = `Successfully uploaded ${uploadedCount} file(s).`;
                    } else if (uploadedCount > 0) {
                        this.alert_type = 'Warning';
                        this.alert_message = `Uploaded ${uploadedCount} file(s). ${failedCount} file(s) failed. ${errors.join(' ')}`;
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = `Failed to upload files. ${errors.join(' ')}`;
                    }
                    this.$refs.alert_model.openModel();
                    return;
                }

                const file = files[index];
                let formData = new FormData();
                formData.append('meeting_id', this.meeting_id);
                formData.append('minutes', 'Minutes Document');
                formData.append('file', file);
                // Don't append status, due_date, or assigned_member for file uploads

                UserService.authPostRequest('store-minutes', formData).then(
                    (response) => {
                        if (response.data.status == 'success') {
                            uploadedCount++;
                            // Update responseData with latest data
                            this.responseData = response.data.data;
                            // Continue with next file
                            uploadNext(index + 1);
                        } else {
                            failedCount++;
                            errors.push(`File "${file.name}": ${response.data.message || 'Upload failed'}`);
                            // Continue with next file even if this one failed
                            uploadNext(index + 1);
                        }
                    },
                    (error) => {
                        failedCount++;
                        const errorMsg = (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                            error.message ||
                            error.toString();
                        errors.push(`File "${file.name}": ${errorMsg}`);
                        // Continue with next file even if this one failed
                        uploadNext(index + 1);
                    }
                );
            };

            // Start uploading from the first file
            uploadNext(0);
        },
        viewFile(fileData, fileName) {
            this.viewerFile = fileData;
            this.viewerFileName = fileName || 'Document';
            $('#fileViewerModal').modal('show');
        },
        closeFileViewer() {
            $('#fileViewerModal').modal('hide');
            // Clear the viewer data after modal is hidden
            setTimeout(() => {
                this.viewerFile = null;
                this.viewerFileName = '';
            }, 300);
        },
        saveMinutes(minutes) {
            this.btnLoading = true;
            minutes.meeting_id = this.meeting_id;
            minutes.editable_id = this.editable_id;
            
            minutes.minutes_assigned_member = this.formatAssignedMemberForApi(this.minutes_assigned_member);
            if (this.editable_id) {
                minutes.minutes = this.minutes;
                minutes.due_date = this.minutes_due_date || null;
                minutes.status = this.minutes_status || null;
                minutes.notes = this.minutes_notes || null;
            } else {
                minutes.due_date = this.minutes_due_date || null;
                minutes.status = this.minutes_status || null;
                minutes.notes = this.minutes_notes || null;
            }

            UserService.authPostRequest('store-minutes', minutes).then(
                (response) => {
                    if (response.data.status == 'success') {
                        $('#addMinutesModel').modal('hide');
                        this.responseData = response.data.data;
                        // Reset form fields
                        this.minutes = '';
                        this.minutes_assigned_member = [];
                        this.minutes_due_date = '';
                        this.minutes_status = '';
                        this.minutes_notes = '';
                        this.editable_id = '';
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btnLoading = false;
                        this.message = '';
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btnLoading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btnLoading = false;
                    } else {
                        this.btnLoading = false;
                    }
                },
                (error) => {
                    this.alert_type = 'Error';
                    this.alert_message = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                    this.$refs.alert_model.openModel();
                    this.btnLoading = false;
                }
            );
        },
        deleteMinutesConfirmation(minutes) {
            var data = {
                editable_id: minutes.id,
                meeting_id: this.meeting_id
            }
            this.dialog_action_params = data;
            this.dialog_message = 'ശരിക്കും ഡിലീറ്റ് ചെയ്യണോ?';
            this.dialog_action = 'deleteMinutes';
            this.$refs.dialog_model.openModel();
            this.loading = false;
        },
        deleteMinutes(data) {
            UserService.authPostRequest('delete-minutes', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.responseData = response.data.data;
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },


        showAddHistoryModal(history = null) {
            this.history = '';
            this.editable_id = '';
            if (history) {
                this.history = history.text;
                this.editable_id = history.id;
            }
            $('#addHistoryModel').modal('show');
        },
        closeAddHistoryModal() {
            $('#addHistoryModel').modal('hide');
        },
        saveHistory(history) {
            this.btnLoading = true;
            history.meeting_id = this.meeting_id;
            history.editable_id = this.editable_id;
            UserService.authPostRequest('store-history', history).then(
                (response) => {
                    if (response.data.status == 'success') {
                        $('#addHistoryModel').modal('hide');
                        this.responseData = response.data.data;
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btnLoading = false;
                        this.message = '';
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btnLoading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btnLoading = false;
                    } else {
                        this.btnLoading = false;
                    }
                },
                (error) => {
                    this.alert_type = 'Error';
                    this.alert_message = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                    this.$refs.alert_model.openModel();
                    this.btnLoading = false;
                }
            );
        },
        deleteHistoryConfirmation(history) {
            var data = {
                editable_id: history.id,
                meeting_id: this.meeting_id
            }
            this.dialog_action_params = data;
            this.dialog_message = 'ശരിക്കും ഡിലീറ്റ് ചെയ്യണോ?';
            this.dialog_action = 'deleteHistory';
            this.$refs.dialog_model.openModel();
            this.loading = false;
        },
        deleteHistory(data) {
            UserService.authPostRequest('delete-history', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.responseData = response.data.data;
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },


        showAddParticipantModal(participant = null) {
            this.participant = '';
            this.editable_id = '';
            if (participant) {
                this.participant = participant.id;
                this.editable_id = participant.id;
            }
            $('#addParticipantModel').modal('show');
        },
        closeAddParticipantModal() {
            $('#addParticipantModel').modal('hide');
        },
        saveParticipant(participant) {
            console.log(participant);
            this.btnLoading = true;
            participant.meeting_id = this.meeting_id;
            participant.editable_id = this.editable_id;
            participant.member_id = this.participant.id;
            UserService.authPostRequest('store-participant', participant).then(
                (response) => {
                    if (response.data.status == 'success') {
                        $('#addParticipantModel').modal('hide');
                        this.responseData = response.data.data;
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btnLoading = false;
                        this.message = '';
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btnLoading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btnLoading = false;
                    } else {
                        this.btnLoading = false;
                    }
                },
                (error) => {
                    this.alert_type = 'Error';
                    this.alert_message = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                    this.$refs.alert_model.openModel();
                    this.btnLoading = false;
                }
            );
        },
        deleteParticipantConfirmation(participant) {
            var data = {
                editable_id: participant.id,
                meeting_id: this.meeting_id
            }
            this.dialog_action_params = data;
            this.dialog_message = 'ശരിക്കും ഡിലീറ്റ് ചെയ്യണോ?';
            this.dialog_action = 'deleteParticipant';
            this.$refs.dialog_model.openModel();
            this.loading = false;
        },
        deleteParticipant(data) {
            UserService.authPostRequest('delete-participant', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.responseData = response.data.data;
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },




        attendanceOpen(meeting) {
            this.editable_id = meeting.id,
                this.attendance = meeting.attendance != 'N' ? meeting.attendance : 'A';
            this.attendance_remarks = meeting.remarks;
            $('#attendanceModel').modal('show');
        },
        onAttendanceCheckboxChange(participant, event) {
            const checked = event.target.checked;
            if (checked && participant.attendance !== 'P') {
                this.setParticipantAttendance(participant, 'P');
                return;
            }
            if (!checked && participant.attendance === 'P') {
                this.setParticipantAttendance(participant, 'N');
                return;
            }
            event.target.checked = participant.attendance === 'P';
        },
        async onSelectAllAttendanceChange(event) {
            const checked = event.target.checked;
            const targets = checked
                ? this.pageParticipants.filter((p) => p.attendance !== 'P')
                : this.pageParticipants.filter((p) => p.attendance === 'P');
            if (targets.length === 0) {
                event.target.checked = checked;
                return;
            }
            this.bulkMarkingAttendance = true;
            try {
                for (const participant of targets) {
                    await this.setParticipantAttendance(participant, checked ? 'P' : 'N');
                }
            } finally {
                this.bulkMarkingAttendance = false;
                event.target.checked = this.allPageParticipantsPresent;
            }
        },
        // Marks present ('P') or unmarks (attendance = 'N') — a genuine two-way toggle.
        setParticipantAttendance(participant, value) {
            if (!participant || participant.attendance === value || this.markingAttendanceIds.includes(participant.id)) {
                return Promise.resolve();
            }
            this.markingAttendanceIds.push(participant.id);
            const data = {
                editable_id: participant.id,
                meeting_id: this.meeting_id,
                attendance: value,
                remarks: ''
            };
            return UserService.authPostRequest('store-meeting-attendance', data).then(
                (response) => {
                    this.markingAttendanceIds = this.markingAttendanceIds.filter((id) => id !== participant.id);
                    if (response.data.status == 'success') {
                        participant.attendance = value;
                        participant.remarks = '';
                        if (response.data.data && response.data.data.meeting) {
                            this.responseData.meeting = response.data.data.meeting;
                        }
                    } else {
                        this.alert_type = response.data.status == 'warning' ? 'Warning' : 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                    }
                },
                (error) => {
                    this.markingAttendanceIds = this.markingAttendanceIds.filter((id) => id !== participant.id);
                    this.alert_type = 'Error';
                    this.alert_message = (error.data && error.data.message) || 'Failed to mark attendance';
                    this.$refs.alert_model.openModel();
                }
            );
        },
        markAttandance() {
            let data = {
                editable_id: this.editable_id,
                meeting_id: this.meeting_id,
                attendance: this.attendance,
                remarks: this.attendance_remarks
            }
            this.loading = true;
            UserService.authPostRequest('store-meeting-attendance', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.responseData = response.data.data;
                        $('#attendanceModel').modal('hide');
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = 'Error';
                    this.alert_message = error.data.message;
                    this.$refs.alert_model.openModel();
                }
            );

        },
        selfAttendance() {
            if (this.self_attendance_btn) {
                this.editable_id = this.responseData.participant_details.id;
                this.attendance = 'P';
                this.markAttandance();
            }
        },
        markComingStatus() {
            let data = {
                editable_id: this.editable_id,
                meeting_id: this.meeting_id,
                attendance: this.attendance,
                remarks: this.attendance_remarks
            }
            this.loading = true;
            UserService.authPostRequest('store-meeting-coming-status', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.responseData = response.data.data;
                        $('#attendanceModel').modal('hide');
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = 'Error';
                    this.alert_message = error.data.message;
                    this.$refs.alert_model.openModel();
                }
            );

        },
        selfComing() {
            if (this.self_coming_btn) {
                this.editable_id = this.responseData.participant_details.id;
                this.attendance = 'P';
                this.markComingStatus();
            }
        },
        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        },
        async downloadMeetingDecisionsPdf() {
            if (!this.meeting_id) return;
            this.decisionsPdfDownloading = true;
            try {
                const response = await UserService.authPostRequest(
                    'meeting-decisions-pdf',
                    { meeting_id: parseInt(this.meeting_id, 10) },
                    { responseType: 'blob' }
                );

                const blob = response.data;
                const contentType = (response.headers && response.headers['content-type']) || '';
                if (contentType.indexOf('application/json') !== -1) {
                    const text = await new Promise((resolve) => {
                        const reader = new FileReader();
                        reader.onload = () => resolve(reader.result);
                        reader.readAsText(blob);
                    });
                    const json = JSON.parse(text);
                    this.alert_type = 'Error';
                    this.alert_message = json.message || 'Failed to generate PDF';
                    this.$refs.alert_model.openModel();
                    return;
                }

                const meetingName = (this.responseData.meeting.meeting_name_mal &&
                    this.responseData.meeting.meeting_name_mal !== 'N')
                    ? this.responseData.meeting.meeting_name_mal
                    : (this.responseData.meeting.meeting_name || 'meeting');
                const safeName = meetingName.replace(/[^a-z0-9\-_]+/gi, '_').substring(0, 40);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `meeting-decisions-${this.meeting_id}-${safeName}.pdf`;
                link.click();
                URL.revokeObjectURL(url);
            } catch (error) {
                this.alert_type = 'Error';
                this.alert_message = (error.response && error.response.data && error.response.data.message)
                    || error.message
                    || 'Failed to generate PDF';
                this.$refs.alert_model.openModel();
            } finally {
                this.decisionsPdfDownloading = false;
            }
        },
        getStatusColor(status) {
            if (!status) return '';
            const statusLower = status.toLowerCase();
            switch (statusLower) {
                case 'assigned':
                    return 'color: #007bff; font-weight: 600;'; // Blue
                case 'in progress':
                    return 'color: #ffc107; font-weight: 600;'; // Yellow/Orange
                case 'on hold':
                    return 'color: #ff9800; font-weight: 600;'; // Orange
                case 'completed':
                    return 'color: #28a745; font-weight: 600;'; // Green
                default:
                    return 'color: #6c757d; font-weight: 600;'; // Gray
            }
        },
        saveQuestianair(data) {
            this.btnLoading = true;
            // data.questians = this.questians_responses;
            data.meeting_id = this.meeting_id;
            UserService.addAdmin('update-meeting-questianair', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.responseData = response.data.data;
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btnLoading = false;
                        this.message = '';
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btnLoading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btnLoading = false;
                    } else {
                        this.btnLoading = false;
                    }
                },
                (error) => {
                    this.alert_type = 'Error';
                    this.alert_message = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                    this.$refs.alert_model.openModel();
                    this.btnLoading = false;
                }
            );
        },
    },
};
</script>
<style scoped>
.list-title {
    font-size: 16px;
    color: black;
}

.item {
    gap: 12px;
    /* margin-bottom: 10px; */
}

.report-btn {
    width: 100% !important;
}

.add-member-btn {
    font-size: 16px !important;
    font-weight: 800 !important;
}

/* .wallet-footer-user {
    height: 46px !important;
} */

.text-only {
    font-size: 13px;
    font-weight: bold;
    color: black;
    /* margin-right: 5px; */
}


.chip-media {
    margin-left: 5px;
    width: 145px !important;
    padding-left: 25px !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.chip-icon {
    width: 50px !important;
}

.chip-label {
    padding: 0px 30px 0px 30px !important;
    font-size: 14px !important;
}

::v-deep .assigned-member-select .vs__dropdown-toggle {
    min-height: 42px;
    border: 1px solid #ced4da;
    border-radius: 8px;
    padding: 4px 6px;
}

::v-deep .assigned-member-select .vs__selected {
    font-size: 14px;
}

::v-deep .assigned-member-select .vs__search {
    font-size: 14px;
}

.bg-pink {
    background-color: #E6A6C7 !important;
}

.bg-pink-dark {
    background-color: #B85887 !important;
}


.wallet-card .wallet-footer .item .icon-wrapper {
    width: 100%;
    height: 48px;
    display: inline-flex;
    align-items: left;
    justify-content: left;
    border-radius: 10px;
    color: #fff;
    /* font-size: 28px; */
    margin-bottom: 14px;
    padding-left: 10px;
}

.menu-icon {
    font-size: 32px !important;
}

.menu-title {
    color: #fff !important;
    font-size: 12px !important;
    padding-left: 5px !important;
    text-align: left !important;
}

.back-color-primary {
    background: #1a418c !important;
}

.back-color-secondary {
    background: #666d79 !important;
}

.back-color-danger {
    background: #de6f56 !important;
}

.back-color-warning {
    background: #b19547 !important;
}

.back-color-red {
    background: #d55454 !important;
}

.back-color-violet {
    background: #072F5F !important;
}

.back-color-blue1 {
    background: #1a418c !important;
}

.back-color-blue2 {
    background: #1a418c !important;
}

.back-color-blue3 {
    background: #1a418c !important;
}

.back-color-blue4 {
    background: #1a418c !important;
}

.back-color-blue5 {
    background: #1a418c !important;
}

.back-color-blue6 {
    background: #1a418c !important;
}

.w-50 {
    width: 50px !important;
}

.goals .item {
    padding: 10px 10px;
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    margin-bottom: 10px;
}

.price-icon {
    /* margin-top: -1%; */
    font-size: 24px;
}

.chip-label[data-v-3bccde2f] {
    padding: 0px 5px 0px 5px !important;
    font-size: 14px !important;
}

.pad-5-left {
    padding-left: 5px;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.avatar-section {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0px;
}

.avatar-section img {
    width: 100%;
    height: 100%;
}

.sl-no {
    font-size: 15px;
}

.green-tick {
    font-size: 18px;
    color: darkgreen;
}

.red-cross {
    font-size: 18px;
    color: red;
}

.questians-label {
    font-weight: 600 !important;
    font-size: 14px !important;

}

.meeting-title {
    font-size: 20px !important;
}

.tick-icon {
    color: green;
    /* Customize the color of the tick icon */
}

.meeting-card {
    background-color: #ffffff;
    border-radius: 8px;
}

.meeting-link {
    text-decoration: none;
    color: inherit;
    display: block;
    padding: 20px;
}

.in {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.meeting-title {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: #333333;
}

.meeting-comment {
    margin: 0;
    font-size: .8rem;
    color: #333333;
}

.status-badge {
    color: #4CAF50;
    font-size: 1.5rem;
}

.title-line {
    border: 0;
    height: 1px;
    margin: 10px 0;
}

.meeting-details {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

.meeting-details-compact {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
}

.meeting-info-compact {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    width: 100%;
    font-size: 0.85rem;
    color: #666666;
}

.info-item {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.info-item ion-icon {
    font-size: 16px;
    color: #1a418c;
}

.info-separator {
    color: #999999;
    margin: 0 2px;
}

.meeting-location-compact {
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
    font-size: 0.85rem;
    color: #666666;
}

.meeting-location-compact ion-icon {
    font-size: 16px;
    color: #1a418c;
    flex-shrink: 0;
}

.meeting-location-compact span {
    word-wrap: break-word;
}

.participant-coming-badge {
    display: block;
    font-size: 0.75rem;
    color: #0d6e2f;
    font-weight: 600;
    margin-bottom: 6px;
    padding: 2px 8px;
    background-color: #d4edda;
    border-radius: 4px;
    border: 1px solid #a3d9a5;
    width: fit-content;
}

.detail-item {
    display: flex;
    align-items: center;
    color: #666666;
    font-size: 0.9rem;
    padding: 10px;
    background-color: #f9f9f9;
    border-radius: 5px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border: 1px solid #e0e0e0;
    height: auto;
    box-sizing: border-box;
    word-wrap: break-word;
}

.detail-icon {
    border-radius: 50%;
    width: 40px;
    height: 40px; 
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 12px;
    background-color: #f0f4f8;
    flex-shrink: 0;
}

.detail-icon ion-icon {
    font-size: 1.25rem;
    color: #011584;
}

.detail-content {
    display: flex;
    flex-direction: column;
    max-width: calc(100% - 52px);
    overflow-wrap: break-word;
}

.detail-label {
    font-size: 0.75rem;
    color: #888888;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.detail-value {
    font-size: 0.95rem;
    color: #333333;
    font-weight: 500;
    word-wrap: break-word;
}

.status-box {
    background-color: #cceac1;
    border-radius: 5px;
    padding: 5px 5px;
    display: inline-block;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.mark-attendance-section {
    background-color: #e7f3ff;
    border-bottom: 1px solid #bee5eb;
}

.mark-attendance-section .item {
    padding: 12px 16px;
}

.meeting-attendance-check-wrap {
    display: flex;
    align-items: center;
    padding-right: 8px;
    flex-shrink: 0;
}

.meeting-attendance-check {
    width: 1.15rem;
    height: 1.15rem;
    margin: 0;
    cursor: pointer;
}

.meeting-attendance-check:disabled {
    cursor: default;
}

.status-text {
    font-size: 0.8rem;
    color: #00796b;
    font-weight: 500;
}
</style>